import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';

export const onboardingHubWizardEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(() =>
		import(/* webpackChunkName: "async-onboarding-hub-wizard" */ './src/ui/index.tsx').then(
			(module) => module.OnboardingWizard,
		),
	),
	getPreloadProps: ({ context }: EntryPointRouteParams) => ({
		extraProps: {
			id: context.match.params?.id || '',
		},
	}),
});
